module.exports = __webpack_public_path__ + "a84c59364a1f8545ca5480ec8ca9ea05.png";